<div class="vote-container">
  <otui-button
    [variant]="isUpvoted ? 'primary' : 'outlined'"
    (action)="upvote()"
    [class.active]="isUpvoted"
    size="sm"
    class="vote-btn"
    title="Like"
  >
    <span class="vote-icon">👍</span>
    @if (isUpvoted) {
    <span class="vote-label">Like</span>
    }
  </otui-button>

  <span class="vote-count">{{ voteCount }}</span>

  <otui-button
    [variant]="isDownvoted ? 'danger' : 'outlined'"
    (action)="downvote()"
    [class.active]="isDownvoted"
    size="sm"
    class="vote-btn"
    title="Dislike"
  >
    <span class="vote-icon">👎</span>
    @if (isDownvoted) {
    <span class="vote-label">Dislike</span>
    }
  </otui-button>
</div>
